import { useEffect, useState } from "react";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useUser } from "@clerk/react";
import { CascaApp } from "@/components/casca/CascaApp";
import { Toaster } from "@/components/ui/sonner";
import { euQuery } from "../consultas";
import { useTempoReal } from "../tempo-real";

/**
 * A casca: menu à esquerda (embaixo, no celular), tela ao lado. Monta UMA vez e fica.
 *
 * Trocar de área troca só o miolo; o dock, a sessão e o aviso em tempo real
 * continuam de pé. É o oposto do app antigo, que refazia tudo no servidor a
 * cada clique.
 */
export function Casca() {
  const { data: eu } = useSuspenseQuery(euQuery());
  const { user } = useUser();
  useTempoReal();

  const usuario = {
    nome: user?.firstName || user?.fullName || user?.primaryEmailAddress?.emailAddress?.split("@")[0] || "Conta",
    email: user?.primaryEmailAddress?.emailAddress ?? "",
    avatar: user?.imageUrl ?? "",
  };

  return (
    // No celular o menu vai para baixo (coluna invertida); do tablet para cima, à esquerda.
    <div className="flex h-dvh flex-col-reverse overflow-hidden bg-[var(--color-fundo)] md:flex-row">
      <BarraDeProgresso />
      <CascaApp clinica={eu.clinica} usuario={usuario} areas={eu.areas} donoDaPlataforma={eu.donoDaPlataforma} />
      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-[var(--color-fundo)]">
        <div className="relative min-h-0 flex-1 overflow-hidden">
          <Outlet />
        </div>
      </main>
      {/* Acima da caixa de escrever da conversa (e, no celular, também da barra do
          menu): embaixo e no centro, o aviso cobria a caixa onde a pessoa ia
          digitar logo depois de "Assumir" (visto em 07/10/2026). */}
      <Toaster position="bottom-center" offset={{ bottom: 92 }} mobileOffset={{ bottom: 140 }} />
    </div>
  );
}

/**
 * Um fio no topo enquanto a próxima tela busca o que falta.
 *
 * A tela de antes FICA até a nova estar pronta — nada de esqueleto nem de
 * pedaços chegando. Se a espera passar de 150ms, este fio avisa que o clique
 * foi ouvido; abaixo disso, ninguém precisa saber.
 */
function BarraDeProgresso() {
  const carregando = useRouterState({ select: (s) => s.isLoading });
  const [visivel, setVisivel] = useState(false);
  useEffect(() => {
    if (!carregando) return setVisivel(false);
    const t = setTimeout(() => setVisivel(true), 150);
    return () => clearTimeout(t);
  }, [carregando]);
  return (
    <div
      aria-hidden
      className={
        "pointer-events-none fixed top-0 right-0 left-0 z-50 h-0.5 origin-left bg-[var(--color-marca)] transition-all duration-500 " +
        (visivel ? "scale-x-75 opacity-100" : "scale-x-0 opacity-0")
      }
    />
  );
}
